
export const MUTATIONS_ACCESS = {
  UPDATE_ACCESS: 'updateAccess',
  CLEAR_ACCESS: 'clearAccess'
};

export default {
  updateAccess(state, access) {
    state.access = access;
  },
  clearAccess(state) {
    state.access = [];
  },
};